import { usePrompt } from '@lmc/ui-kit/src/utils/usePrompt'
import NavigationModal, { NavigationModalProps } from './NavigationModal'

export type NavigationPromptModalProps = Omit<
  NavigationModalProps,
  'showPrompt' | 'confirmNavigation' | 'cancelNavigation'
> & {
  canNavigate: boolean
}

const NavigationPromptModal = ({
  canNavigate,
  ...props
}: NavigationPromptModalProps) => {
  const [showPrompt, confirmNavigation, cancelNavigation] = usePrompt(
    !canNavigate
  )

  return (
    <NavigationModal
      showPrompt={showPrompt}
      confirmNavigation={confirmNavigation}
      cancelNavigation={cancelNavigation}
      {...props}
    />
  )
}

export default NavigationPromptModal
